import React from "react";
import image from "../Images/salon.jpeg";
function AboutInfo() {
  return (
    <section className='aboutinfo-section'>
      <div className='aboutinfo-container'>
        <h4>About Us</h4>
        <div className='info'>
          <img src={image} alt='salon' />
          <p>
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Reiciendis
            tenetur vitae incidunt excepturi! Ad nobis nisi quo quod
            reprehenderit expedita amet odit consequuntur quis! Iste delectus
            exercitationem dignissimos culpa at animi aliquam dolorem
            perferendis. Quas consequuntur obcaecati alias eum cupiditate
            deserunt nostrum facere in sit beatae! Odio nisi maxime eum,
            repudiandae aliquid perspiciatis blanditiis temporibus ducimus
            molestiae vel quia commodi, ea provident, minus consequatur ratione
            cupiditate accusantium ut ex accusamus quaerat magnam illum?
            Officiis consectetur ea eius, molestias deserunt modi, reiciendis
            distinctio non, consequuntur odit obcaecati. Ipsa repellat ducimus
            soluta asperiores obcaecati numquam, corporis mollitia assumenda
            dolore, explicabo, natus earum? Lorem, ipsum dolor sit amet
            consectetur adipisicing elit. Accusantium delectus vero blanditiis
            molestiae quia a ad asperiores facere quo optio similique numquam
            voluptatem sed minus repudiandae doloribus assumenda, omnis quam
            eligendi aliquid enim nesciunt sequi consequatur maxime. Unde
            eligendi eum quidem officia esse, molestiae alias sunt cumque
            dolore. Tempore nemo unde ut neque modi iusto ipsum doloribus est.
            Dolor dolores unde debitis natus inventore tempora eveniet ratione
            voluptate rem praesentium ipsa facilis aut nobis consequatur, quos
            exercitationem voluptatibus soluta, voluptatem, illo modi tenetur
            eligendi dicta? Odio, repudiandae beatae at maxime voluptates earum
            amet! Aliquid ullam quae, quo illo nostrum quisquam?
          </p>
        </div>
      </div>
    </section>
  );
}

export default AboutInfo;
